import React from 'react'
import GodCard from './GodCard';
import '../../../styles/containers/Prayer/components/faith-gods.scss';
function FaithGods({selectedFaith, selectedFaithObj, selectedGod, setSelectedGod}) {
    const handleClick = function(godKey) {
        if(selectedGod === godKey) {
            setSelectedGod('');
        } else {
            setSelectedGod(godKey);
        }
    }
    let GodsElement = [];
    let myFaithGods = selectedFaithObj.gods;
    for(let i = 0; i < myFaithGods.length; i+=2) {
        if(i + 1 < myFaithGods.length) {
            GodsElement.push(
                <div key={i+1} className="row justify-content-between row-margin">
                    <div className="col d-flex justify-content-center" 
                    onClick={() => handleClick(myFaithGods[i].key)}>
                       <GodCard god={myFaithGods[i]} 
                       godSelected={selectedGod === myFaithGods[i].key}/>
                    </div> 
                    <div className="col d-flex justify-content-center"
                    onClick={() => handleClick(myFaithGods[i+1].key)}>
                        <GodCard god={myFaithGods[i+1]} 
                        godSelected={selectedGod === myFaithGods[i+1].key}/>
                    </div>
                </div>
            )
        } else {
            GodsElement.push(
                <div key={i+1} className="row justify-content-center row-margin">
                    <div className="col d-flex justify-content-center" 
                    onClick={() => handleClick(myFaithGods[i].key)}
                    >
                       <GodCard god={myFaithGods[i]} 
                       godSelected={selectedGod === myFaithGods[i].key}/>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className='faith-gods-container'>
            {GodsElement}
        </div>
    )
}

export default FaithGods
